export default "__VITE_ASSET__Dnnfo5w3__"